import { ModalProps } from 'featureSliced/shared/store/reducers/ModalsReducer/types'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import {
  IBucketProduct,
  IProductWithBucketProduct,
} from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { findCatalogProduct } from 'featureSliced/shared/utils/findCatalogProduct'
import { UpdateProduct } from './modals/UpdateProduct'

export type OpenProductModalType = (
  product: IBucketProduct,
  categoryName?: string
) => void

export const useUpdateBucketProduct = (): OpenProductModalType => {
  const openModal = useOpenModal()
  const productsList = useMySelector((state) =>
    state.categories.items.flatMap((cat) => cat.products)
  )

  const openProductModal = (product: IBucketProduct) => {
    const getFullProduct = () => {
      // falls back to innerCategoryItems — a Specials/sub-template line's product
      // is not in the top-level list (QRM-649)
      const ogProduct = findCatalogProduct(productsList, product.productId)
      return {
        ...ogProduct,
        ...product,
      }
    }

    openModal({
      id: `ADD_PRODUCT_${product.uniqueId}`,
      components: [
        ({ closeThisModal }: ModalProps) => (
          <UpdateProduct
            product={getFullProduct() as IProductWithBucketProduct}
            bucketProduct={product}
            closeProduct={closeThisModal}
          />
        ),
      ],
    })
  }

  return openProductModal
}
